import { useContext, useMemo } from "react";

import { TenantContext } from "../templates/context/TenantContext";

import { useDataIntegration } from "../model/useDataIntegration";

const levelNumber = (nivel) => parseInt(String(nivel).replace("level", ""), 10);

/**
 * Os campos de resumo (predição, histórico de vendas, tipo e volume) se repetem em cada item de
 * `dataIntegration`, por isso o card de KPIs lê do primeiro item.
 *
 * A API ainda não envia a hierarquia de lojas, então `storeHierarchy` fica vazio até lá.
 */
export const useDataIntegrationViewModel = () => {
  const { hierarchy: tenantHierarchy } = useContext(TenantContext);

  const {
    dataIntegration,
    hierarchy,
    isLoadingDataIntegration,
    dataIntegrationError,
  } = useDataIntegration();

  const summary = useMemo(() => {
    const first = dataIntegration?.[0];
    if (!first) return null;

    return {
      lastPrediction: first.lastIAPrediction,
      salesHistory: {
        days: first.salesDaysCount,
        startDate: first.earliestSalesDate,
        endDate: first.latestSalesDate,
      },
      integrationType: first.integrationType,
      dataVolume: first.dataVolume,
    };
  }, [dataIntegration]);

  const integrations = useMemo(() => (dataIntegration ?? []).map((item) => ({
    id: item.dataIntegrationId,
    name: item.integrationFlow,
    source: item.integrationType,
    status: item.status,
    startedAt: item.begin,
    finishedAt: item.end,
    duration: item.duration,
  })), [dataIntegration]);

  const productHierarchy = useMemo(() => [...(hierarchy ?? [])]
    .sort((a, b) => levelNumber(a.nivel) - levelNumber(b.nivel))
    .map((item) => ({
      level: item.nivel,
      label: tenantHierarchy?.labels?.[item.nivel] ?? item.nivel,
      count: item.nos,
    })), [hierarchy, tenantHierarchy]);

  return {
    ctx: {
      summary,
      integrations,
      productHierarchy,
      storeHierarchy: [],
    },
    uiState: {
      isLoading: isLoadingDataIntegration,
      hasError: Boolean(dataIntegrationError),
    },
  };
};
